/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const GetMonthlyCoveragePlanById = zod.object({
  "id": zod.string().uuid().optional(),
  "payload": zod.string().uuid().optional()
});

export type GetMonthlyCoveragePlanById = zod.input<typeof GetMonthlyCoveragePlanById>;
export type GetMonthlyCoveragePlanByIdOutput = zod.output<typeof GetMonthlyCoveragePlanById>;
